// dependencies imports ⇒
import React from "react";
// assets and scss imports ⇒
import "./signInContainer.scss";

// project file imports(UI components) ⇒
import DoctorSlugBooking from "../../components/PatientSignInContainer/DoctorSlugBooking/doctorSlugBooking";
// const file imports(helper methods, etc) ⇒

const SignInContainer = (props) => {
  const { renderComp, isPatient, loginImage, loginMobileImage } = props;
  // const declarations ⇒

  // let or var declarations ⇒

  // life cycle methods ⇒

  // API Calls ⇒

  // Helper methods ⇒

  // Actions ⇒

  // create UI ⇒

  const SignInLayoutUI = () => {
    return (
      <div className="signin-wrapper-container">
        <div className="signin-wrapper-logo-container">
          <img className="signin-wrapper-logo" src={loginImage} alt="" />
          <img
            className="signin-wrapper-logo-mobile"
            src={loginMobileImage}
            alt=""
          />
          {window.innerWidth > 768 && isPatient && <DoctorSlugBooking />}
        </div>
        <div className="signin-wrapper-sign-in-form-container">
          {renderComp}
        </div>
      </div>
    );
  };

  return (
    <div className="signin-wrapper-sign-in-container">{SignInLayoutUI()}</div>
  );
};

// export ⇒
export default SignInContainer;
